// ============ CRAVE cart, shipping, and upgrade-popup behavior ============
var CRAVE_FREE_SHIPPING_CENTS = 5999; // Free shipping threshold: matches the 12-pack price ($59.99)

function craveMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function craveRenderShipBar(cart, msgEl, fillEl, barEl) {
  if (!barEl) return;
  if (cart.item_count === 0) { barEl.style.display = 'none'; return; }
  barEl.style.display = 'block';
  var remaining = CRAVE_FREE_SHIPPING_CENTS - cart.total_price;
  var pct = Math.min(100, (cart.total_price / CRAVE_FREE_SHIPPING_CENTS) * 100);
  if (fillEl) fillEl.style.width = pct + '%';
  if (msgEl) {
    msgEl.innerHTML = remaining > 0
      ? 'You\'re <strong style="color:var(--red);">' + craveMoney(remaining) + '</strong> away from free shipping'
      : '🎉 You\'ve unlocked free shipping!';
  }
}

function craveRenderCartPanel(cart) {
  var itemsEl = document.getElementById('craveCartItems');
  var subtotalRow = document.getElementById('craveCartSubtotalRow');
  var subtotalEl = document.getElementById('craveCartSubtotal');
  var countEl = document.getElementById('craveCartCount');
  if (!itemsEl) return;

  if (countEl) countEl.textContent = cart.item_count;
  craveRenderShipBar(cart, document.getElementById('craveShipMsg'), document.getElementById('craveShipFill'), document.getElementById('craveShipBar'));

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '<p class="cart-panel-empty">Your cart is empty.</p>';
    if (subtotalRow) subtotalRow.style.display = 'none';
    return;
  }

  if (subtotalRow) subtotalRow.style.display = 'flex';
  if (subtotalEl) subtotalEl.textContent = craveMoney(cart.total_price);

  itemsEl.innerHTML = cart.items.map(function (item) {
    return '<div class="cart-panel-item">' +
      '<img src="' + (item.image || '') + '&width=100" alt="' + item.product_title + '">' +
      '<div class="cart-panel-item-info">' +
      '<div class="cart-panel-item-title">' + item.product_title + '</div>' +
      '<div class="cart-panel-item-meta">' + item.variant_title + ' · Qty ' + item.quantity + '</div>' +
      '</div>' +
      '<div class="cart-panel-item-price">' + craveMoney(item.final_line_price) + '</div>' +
      '</div>';
  }).join('');
}

function craveRefreshCart() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(function (r) { return r.json(); })
    .then(craveRenderCartPanel)
    .catch(function () {});
}

function craveEnsurePanelOnBody() {
  var panel = document.getElementById('craveCartPanel');
  if (panel && window.matchMedia('(max-width: 800px)').matches && panel.parentNode !== document.body) {
    document.body.appendChild(panel);
  }
}

window.craveOpenCartPanel = function () {
  craveEnsurePanelOnBody();
  var cartPanel = document.getElementById('craveCartPanel');
  var backdrop = document.getElementById('craveCartBackdrop');
  if (cartPanel) cartPanel.classList.add('open');
  if (window.matchMedia('(max-width: 800px)').matches) {
    if (backdrop) backdrop.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  document.body.classList.add('crave-cart-open');
};

window.craveAddHeroDeal = function (variantId, buttonEl) {
  if (!variantId) return;
  var labelEl = buttonEl.querySelector('strong');
  var originalLabel = labelEl ? labelEl.textContent : '';
  if (buttonEl) buttonEl.classList.add('is-adding');
  if (labelEl) labelEl.textContent = 'ADDING…';

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
    .then(function (r) { if (!r.ok) throw new Error('failed'); return r.json(); })
    .then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (document.getElementById('craveCartPanel')) {
        craveOpenCartPanel();
      }
      if (labelEl) labelEl.textContent = 'ADDED ✓';
    })
    .catch(function () {
      if (labelEl) labelEl.textContent = 'TRY AGAIN';
    })
    .finally(function () {
      setTimeout(function () {
        if (buttonEl) buttonEl.classList.remove('is-adding');
        if (labelEl) labelEl.textContent = originalLabel;
      }, 1500);
    });
};

document.addEventListener('DOMContentLoaded', function () {
  craveRefreshCart();
  craveEnsurePanelOnBody();
  window.addEventListener('resize', craveEnsurePanelOnBody);

  // Force-reset the cart panel/backdrop whenever this page is shown,
  // including when restored from the mobile browser's back-forward cache
  // (bfcache) — otherwise a stale "open" grey overlay can get stuck on
  // screen with no way to dismiss it after using the back button.
  window.addEventListener('pageshow', function (event) {
    var panel = document.getElementById('craveCartPanel');
    var backdrop = document.getElementById('craveCartBackdrop');
    if (panel) panel.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.body.classList.remove('crave-cart-open');
  });

  // ---------- Cart dropdown open/close ----------
  var toggle = document.getElementById('craveCartToggle');
  var panel = document.getElementById('craveCartPanel');
  var wrap = document.getElementById('craveCartWrap');
  var backdrop = document.getElementById('craveCartBackdrop');
  var closeBtn = document.getElementById('craveCartClose');
  var isMobile = function () { return window.matchMedia('(max-width: 800px)').matches; };

  function openCart() {
    if (panel) panel.classList.add('open');
    if (isMobile() && backdrop) backdrop.classList.add('open');
    if (isMobile()) document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('crave-cart-open');
  }
  function closeCart() {
    if (panel) panel.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.documentElement.style.overflow = '';
    document.body.classList.remove('crave-cart-open');
  }

  if (toggle && panel) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      craveEnsurePanelOnBody();
      if (panel.classList.contains('open')) closeCart(); else openCart();
    });
    document.addEventListener('click', function (e) {
      if (!isMobile() && wrap && !wrap.contains(e.target)) closeCart();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (backdrop) backdrop.addEventListener('click', closeCart);
  document.addEventListener('cart:refresh', craveRefreshCart);

  // ---------- Standard product/bundle add-to-cart forms ----------
  document.querySelectorAll('[data-crave-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      // Bundle-selector forms for non-top-tier cards get intercepted by the
      // upgrade popup below; skip the normal handler for those so we don't
      // double-submit.
      if (form.dataset.upgradeHandled === 'pending') return;

      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('.form-status');
      const original = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Cart request failed');
        if (status) status.textContent = 'Added to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var cartPanel = document.getElementById('craveCartPanel');
        if (cartPanel) {
          craveOpenCartPanel();
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      } catch (error) {
        if (status) status.textContent = 'Could not add this item. Please try again.';
      } finally {
        if (button) { button.disabled = false; button.textContent = original; }
      }
    });
  });

  // ---------- Pre-add-to-cart upgrade popup (bundle selector only) ----------
  var overlay = document.getElementById('craveUpgradeOverlay');
  var card = document.getElementById('craveUpgradeCard');

  function parseMoney(str) {
    if (!str) return 0;
    return Math.round(parseFloat(str.replace(/[^0-9.]/g, '')) * 100);
  }
  function parseProtein(str) {
    if (!str) return 0;
    var m = str.match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  document.querySelectorAll('[data-bundle-section] [data-bundle-card]').forEach(function (thisCard) {
    var rank = parseInt(thisCard.dataset.rank, 10);
    if (rank === 0) return; // top tier (Best Value) has nothing to upgrade to

    var grid = thisCard.closest('.bundle-grid');
    var nextCard = grid ? grid.querySelector('[data-rank="' + (rank - 1) + '"]') : null;
    if (!nextCard) return;

    var form = thisCard.querySelector('[data-crave-product-form]');
    if (!form) return;

    form.dataset.upgradeHandled = 'pending';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var currentPrice = parseMoney(thisCard.dataset.price);
      var nextPrice = parseMoney(nextCard.dataset.price);
      var currentProtein = parseProtein(thisCard.dataset.protein);
      var nextProtein = parseProtein(nextCard.dataset.protein);
      var proteinGain = nextProtein - currentProtein;
      var savings = (currentPrice * 2) - nextPrice;
      var nextVariantId = nextCard.dataset.variantId;
      var currentVariantId = thisCard.dataset.variantId;

      if (!overlay || !card || savings <= 0) {
        submitBundleForm(form, currentVariantId, thisCard.dataset.label);
        return;
      }

      var freeShipNote = (rank - 1 === 0)
        ? '<div class="crave-upgrade-ship-note">+ Unlocks FREE shipping (worth $6.99)</div>'
        : '';

      card.innerHTML =
        '<span class="crave-upgrade-badge">Before You Add This</span>' +
        '<h3>Upgrade to the ' + nextCard.dataset.label + ' and save ' + craveMoney(savings) + '</h3>' +
        '<p>You get ' + proteinGain + 'g more protein and a better per-bag price than buying ' + thisCard.dataset.label + ' twice.</p>' +
        '<div class="crave-upgrade-compare">' +
        '<div class="crave-upgrade-tier"><div class="t-label">' + thisCard.dataset.label + '</div><div class="t-price">' + craveMoney(currentPrice) + '</div></div>' +
        '<div class="crave-upgrade-arrow">→</div>' +
        '<div class="crave-upgrade-tier is-new"><div class="t-label">' + nextCard.dataset.label + '</div><div class="t-price">' + craveMoney(nextPrice) + '</div></div>' +
        '</div>' +
        freeShipNote +
        '<button type="button" class="button" id="craveUpgradeYes">YES, UPGRADE TO ' + nextCard.dataset.label.toUpperCase() + '</button>' +
        '<button type="button" class="crave-upgrade-skip" id="craveUpgradeNo">No thanks, ' + thisCard.dataset.label + ' is fine</button>';

      overlay.classList.add('show');

      document.getElementById('craveUpgradeYes').addEventListener('click', function () {
        overlay.classList.remove('show');
        submitBundleForm(form, nextVariantId, nextCard.dataset.label);
      });
      document.getElementById('craveUpgradeNo').addEventListener('click', function () {
        overlay.classList.remove('show');
        submitBundleForm(form, currentVariantId, thisCard.dataset.label);
      });
    });
  });

  function submitBundleForm(form, variantId, label) {
    var status = form.querySelector('.form-status');
    var button = form.querySelector('button[type="submit"]');
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('failed'); return r.json(); })
      .then(function () {
        if (status) status.textContent = 'Added ' + label + ' to cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (document.getElementById('craveCartPanel')) {
          craveOpenCartPanel();
        }
      })
      .catch(function () { if (status) status.textContent = 'Could not add this item. Please try again.'; })
      .finally(function () { if (button) { button.disabled = false; button.textContent = original; } });
  }

  // ---------- Cart page: shipping bar ----------
  var cartPageShipBar = document.getElementById('craveCartPageShipBar');
  if (cartPageShipBar) {
    craveRenderShipBar(
      { item_count: parseInt(cartPageShipBar.dataset.itemCount, 10), total_price: parseInt(cartPageShipBar.dataset.totalPrice, 10) },
      document.getElementById('craveCartPageShipMsg'),
      document.getElementById('craveCartPageShipFill'),
      cartPageShipBar
    );
  }

  // ---------- Cart page: smooth AJAX quantity/remove (no page reloads) ----------
  var cartList = document.getElementById('craveCartItemsList');
  if (cartList) {
    function updateLine(key, quantity, lineEl) {
      lineEl.classList.add('is-updating');
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (quantity === 0) {
            lineEl.classList.add('is-removing');
            setTimeout(function () {
              lineEl.remove();
              if (cart.item_count === 0) window.location.reload();
            }, 200);
          } else {
            var item = cart.items.find(function (i) { return i.key === key; });
            if (item) {
              lineEl.querySelector('[data-qty-value]').textContent = item.quantity;
              lineEl.querySelector('[data-line-price]').textContent = craveMoney(item.final_line_price);
            }
            lineEl.classList.remove('is-updating');
          }
          var subtotalEl = document.querySelector('[data-cart-subtotal]');
          if (subtotalEl) subtotalEl.textContent = craveMoney(cart.total_price);
          craveRenderShipBar(cart, document.getElementById('craveCartPageShipMsg'), document.getElementById('craveCartPageShipFill'), cartPageShipBar);
          craveRefreshCart();
        })
        .catch(function () { lineEl.classList.remove('is-updating'); });
    }

    cartList.addEventListener('click', function (e) {
      var lineEl = e.target.closest('[data-cart-line]');
      if (!lineEl) return;
      var key = lineEl.dataset.key;
      var qtyEl = lineEl.querySelector('[data-qty-value]');

      if (e.target.closest('[data-qty-increase]')) {
        updateLine(key, parseInt(qtyEl.textContent, 10) + 1, lineEl);
      } else if (e.target.closest('[data-qty-decrease]')) {
        var next = parseInt(qtyEl.textContent, 10) - 1;
        updateLine(key, Math.max(0, next), lineEl);
      } else if (e.target.closest('[data-cart-remove]')) {
        updateLine(key, 0, lineEl);
      }
    });
  }
});